import React from 'react';
import PropTypes from 'prop-types';

// TRANSLATIONS
import { useTranslation } from 'react-i18next';

// STYLE
import { useNavigate } from 'react-router-dom';
import style from '../../../../scss/components/buttons/button.module.scss';

const DiscardDraftButton = ({ hasDraft, onDiscardDraft }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    if (!hasDraft || !onDiscardDraft) {
        return null;
    }

    const handleDiscard = async () => {
        const confirmed = window.confirm(
            t(
                'application.discardDraftConfirm',
                'Are you sure you want to discard the draft?',
            ),
        );

        if (!confirmed) {
            return;
        }

        await onDiscardDraft();
        setTimeout(() => navigate(0), 1000);
    };

    return (
        <button
            className={`${style.basic} ${style.deleteText}`}
            type="button"
            onClick={handleDiscard}
        >
            {t('application.discardDraft', 'Discard draft')}
        </button>
    );
};

DiscardDraftButton.propTypes = {
    hasDraft: PropTypes.bool,
    onDiscardDraft: PropTypes.func,
};

DiscardDraftButton.defaultProps = {
    hasDraft: false,
    onDiscardDraft: null,
};

export default DiscardDraftButton;
